// Must stay the first import, see zodConfig.ts
import "./zodConfig";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router";
import { AuthProvider } from "./auth/AuthProvider";
import { RuntimeConfigProvider } from "./config/RuntimeConfigProvider";
import { InternationalizationProvider } from "./i18n/InternationalizationProvider";
import { AppRoutes } from "./pages/router";

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <InternationalizationProvider>
      <QueryClientProvider client={queryClient}>
        <RuntimeConfigProvider>
          <BrowserRouter>
            <AuthProvider>
              <AppRoutes />
            </AuthProvider>
          </BrowserRouter>
        </RuntimeConfigProvider>
        {import.meta.env.DEV && <ReactQueryDevtools />}
      </QueryClientProvider>
    </InternationalizationProvider>
  </StrictMode>,
);
